import { render, staticRenderFns } from "./businessonebox-alloutboxsourcesystem.vue?vue&type=template&id=a80058b6&"
import script from "./businessonebox-alloutboxsourcesystem.vue?vue&type=script&lang=js&"
export * from "./businessonebox-alloutboxsourcesystem.vue?vue&type=script&lang=js&"
import style0 from "./businessonebox-alloutboxsourcesystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports